module.exports = __webpack_public_path__ + "static/media/dma-logo.67ca470c.svg";